import { HttpStatusCode } from "../../../../common/infra/http-status/http-status";
import { BackedApi } from "../../../../config/urls/Api";
import { Workout } from "../../application/domain/workout";
import { ResponseCreateWorkoutDto } from "./dto/response-create-workout.dto";
import { ResponseDeleteWorkoutDto } from "./dto/response-delete-workout.dto";
import { ResponseGetWorkoutDto } from "./dto/response-get-workout.dto";
import { ResponseListWorkoutsDto } from "./dto/response-list-workouts.dto";

export class WorkoutsRepository {
    static async list(drillId: string): Promise<ResponseListWorkoutsDto> {    
        const response = await this.sendRequest(
            BackedApi.ListWorkouts(drillId).url,
            BackedApi.ListDrills.method,            
        )
        const data = await response.json();
        const status = response.status;
        return { data, error: status !== HttpStatusCode.OK, status };
    }

    static async create(workout: Workout): Promise<ResponseCreateWorkoutDto> {
        const response = await this.sendRequest(
            BackedApi.CreateWorkout.url,
            BackedApi.CreateWorkout.method,
            workout
        )
        const data = await response.json();
        const status = response.status;
        return { data, error: status !== HttpStatusCode.CREATED, status };
    }

    static async getByWorkout(workoutId: string): Promise<ResponseGetWorkoutDto> {
        const { url, method } = BackedApi.GetWorkout(workoutId);
        const response = await this.sendRequest(url, method);
        const data = await response.json();
        const status = response.status;
        return { data, error: status !== HttpStatusCode.OK, status };
    }

    static async delete(workoutId: string): Promise<ResponseDeleteWorkoutDto> {
        const { url, method } = BackedApi.DeleteWorkout(workoutId);
        const response = await this.sendRequest(url, method);
        const status = response.status;
        const text = await response.text();
        let data: unknown;
        if (text.trim()) {
            try {
                data = JSON.parse(text);
            } catch {
                data = undefined;
            }
        }
        const ok =
            status === HttpStatusCode.NO_CONTENT ||
            status === HttpStatusCode.OK;
        return { data, error: !ok, status };
    }

    private static async sendRequest(url: string, method: string, body?: any) {
        const response = await fetch(url, {
            method,
            credentials: 'include',
            ...(body != null && {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body),
            }),
        })
        return response;
    }
}